import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const getDefaultState = () => {
    return {
        search: null,
        selectedCategories: [],
        selectedCommunes: [],
        selectedProviderStates: [],
        selectedTags: [],
        selectedTourismSectors: [],
        selectedBusinessStatus: [],
        emailSearch: null,
    }
}

const vtcFilter = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setSearch(state, value) {
            state.search = value
        },
        setEmailSearch(state, value) {
            state.emailSearch = value
        },
        setSelectedCategories(state, value) {
            state.selectedCategories = value
        },
        setSelectedCommunes(state, value) {
            state.selectedCommunes = value
        },
        setSelectedProviderStates(state, value) {
            state.selectedProviderStates = value
        },
        setSelectedTourismSectors(state, value) {
            state.selectedTourismSectors = value
        },
        setSelectedTags(state, value) {
            state.selectedTags = value
        },
        setSelectedBusinessStatus(state, value) {
          state.selectedBusinessStatus = value
        },
        pushWebFormState(state, value) {
            if(!state.selectedProviderStates.includes(value)) {
                state.selectedProviderStates.push(value)
            }
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default vtcFilter